import { CustomStorage } from "../utils/storage";
import { v4 as uuidv4 } from "uuid";

import { getToken, getUserId } from "../utils/auth";
import { parseJwt } from "../utils/formatters";

type eventType =
	| "clicked_continue_checkout_my_interests"
	| "clicked_scholarship_carousel"
	| "click_start_checkout"
	| "clicked_how_to_get_scholarship_detailspage"
	| "saw_details"
	| "saw_pravaler_banner_details"
	| "clicked_pravaler_banner_details"
	| "clicked_trustfooter_media"
	| "clicked_trustfooter"
	| "open_whatsapp"
	| "clicked_on_the_popover_my_interests"
	| "clicked_change_city_scholarship"
	| "clicked_cta_home_scholarship"
	| "submitted_course_level_scholarship"
	| "submitted_course_scholarship"
	| "submitted_city_scholarship"
	| "submitted_time_to_join_scholarship"
	| "skipped_time_to_join_scholarship"
	| "skipped_lead_form_scholarship"
	| "submitted_lead_form_scholarship"
	| "changed_ip_suggested_city_scholarship"
	| "saw_home_scholarship"
	| "open_whatsapp_scholarship"
	| "clicked_xpeed_card"
	| "saw_home"
	| "clicked_garantircurso_details_prv"
	| "clicked_poll_course"
	| "saw_poll_course"
	| "clicked_partner_logo"
	| "saw_institution_page"
	| "saw_partners_page";

export const createEvent = (type: eventType, data?: any) => {
	const storage = new CustomStorage();
	const token = getToken(storage);
	let parsedJwt;

	if (token) {
		parsedJwt = parseJwt(token);
	}

	const userId = getUserId(storage);
	const deviceId = storage.getItem("deviceId") ? storage.getItem("deviceId") : uuidv4();
	const sessionId = sessionStorage.getItem("sessionId") ? sessionStorage.getItem("sessionId") : uuidv4();

	const { path, search } = window && typeof window !== "undefined" ? { path: window.location.pathname, search: window.location.search } : null;

	storage.setItem("deviceId", deviceId);
	sessionStorage.setItem("sessionId", sessionId);

	const url = process.env.NEXT_PUBLIC_API_TRACKING;

	if (data?.searchSessionId) {
		data.searchSessionId = `${data.searchSessionId.substr(0, 8)}${deviceId.substr(0, 8)}`;
	}

	const dataBody = {
		...data,
		...(parsedJwt ? { impersonated: parsedJwt.type === "IMPERSONATE" } : {}),
	};

	if (typeof window !== "undefined") {
		import("amplitude-js").then((amplitude) => {
			amplitude?.getInstance().logEvent(type, dataBody);
		});
	}

	if (url) {
		fetch(url, {
			body: JSON.stringify({
				data: dataBody,
				deviceId,
				path,
				sessionId,
				type,
				urlParams: path + search,
				userId: userId?.length > 0 ? userId : undefined,
				userToken: token || "",
			}),
			headers: {
				"Content-Type": "application/json",
			},
			method: "POST",
		});
	}
};
